import * as ActionTypes from './../constants';
import { baseUrl } from './../actions';
import axios from 'axios';
import AsyncStorage from '@react-native-community/async-storage';
import { getUserToken } from './getUserToken';
 

const dispatchRequestPaymentForCreateTest = () => ({
    type: ActionTypes.REQUEST_PAYMENT_FOR_CREATE_TEST
})

const dispatchSuccessPaymentForCreateTest = (res, isFreeChallenge) => ({
    type: ActionTypes.SUCCESS_PAYMENT_FOR_CREATE_TEST,
    res,
    isFreeChallenge
})

const dispatchErrorFailureForCreateTest = (err, isFreeChallenge) => ({
    type: ActionTypes.FAILURE_PAYMENT_FOR_CREATE_TEST,
    err,
    isFreeChallenge
})

const dispatchClearPaymentForCreateTest = () => ({
    type: ActionTypes.CLEAR_PAYMENT_FOR_CREATE_TEST
})

export const clearAllPaymentForCreateTestData = () => dispatchClearPaymentForCreateTest();





export const checkoutCreateTest = (data, testId, bidAmount, testName, transactionFor, id) => (dispatch, getState) => { 
   
    AsyncStorage.getItem('authKey', (err, res) => {  
        // console.log(data)
        
        dispatch(dispatchRequestPaymentForCreateTest(data));        
        // if(err) return dispatch(dispatchErrorFailureForCreateTest('something went wrong...', err));
        // if(!transactionFor) return dispatch(dispatchErrorFailureForCreateTest('something went wrong...', {}));
        
        const {userDetails} = getState().homeData;
        let username, email, phone, isFreeChallenge;
    //    console.log(userDetails, "sad")
        // const {receipt, productId, store, purchaseInfo} = IAP;
        // const {originalTransactionIdentifierIOS, transactionDate, originalTransactionDateIOS, null} = purchaseInfo || {};

        // if(userDetails && Object.keys(userDetails)) {
        //     return  username = userDetails.username,
        //     email = userDetails.email,
        //     phone = userDetails.phone
           
        // }

        const payment_id =  data && data.razorpay_payment_id || null;
        const description = `Paid by ${username || 'user'} towards ${transactionFor}`

        let options = {
            method: 'post',
            headers: {
                Authorization: `Bearer ${res}`
            }
        };

        if(transactionFor === ActionTypes.FOR_LIBRARY_CONTENT) {
            options = {
                ...options,
                url:  `${baseUrl}/api/receive_material_payment`,
                data: {
                    library_subject_id: id,
                    // payment_id,
                    payment_id: payment_id,
                    amount: 1,
                  
                }
            }
        }
        if(transactionFor === ActionTypes.FOR_TEST_SERIES) {
            options = {
                ...options,
                url: `${baseUrl}/api/receive_mockseries_payment`,
                data: {
                // payment_id,
                payment_id: payment_id,
                mockseries_code: id,
                amount: 1,
               
                }
            }
        }

        if(transactionFor === ActionTypes.FOR_COURSE) {
            options = {
                ...options,
                url: `${baseUrl}/api/receive_course_payment`,
                data: {
                // payment_id,
                payment_id: payment_id ? payment_id : null,
                course_id: id,
                amount: parseInt(bidAmount, 10) * 100,

                }
            }
        }
      

        axios(options).then( ({data}) => {
            // console.log(data)
            // alert(JSON.stringify(data));
            dispatch(dispatchSuccessPaymentForCreateTest(data, isFreeChallenge))
        }).catch(e => {               
            // alert(JSON.stringify(e));
            // alert(JSON.stringify(e.response))
            // console.log(e)
            dispatch(dispatchErrorFailureForCreateTest(e, isFreeChallenge));
        })
        //   function sendPaymentStatus(data, status, transactionFor, amount) {

          
        //     const payment_id =  data && data.razorpay_payment_id || null;
         
        // }

        // alert('Under Development')
        //   RazorpayCheckout.open(razorPayOptions).then((data) => {
            // handle success
            // alert(`Success: ${data.razorpay_payment_id}`);
            // axios({
            //   url: 'http://toothepoint.appspot.com/paysuccess',
            //   method: 'post',
            //   data: {
            //     payment_id: data.razorpay_payment_id,
            //     amount: 100
            //   }
            // }).then(res => console.log(res))
            // .catch(e => console.log(e, 'error'));         



        //     if(data.razorpay_payment_id) {
        //         sendPaymentStatus(data, 'success', transactionFor);
        //     }else{
        //         dispatch(dispatchErrorFailureForCreateTest('something went wrong...', res, 'response error'));
        //     }            
        //   }).catch((error) => {
        //     // handle failure
        //     sendPaymentStatus(null, 'failed', transactionFor);
        //     dispatch(dispatchErrorFailureForCreateTest('something went wrong...', error.description, 'response error'));
        //     // alert(`Error: ${error.code} | ${error.description}`);
        //   });
      
    })

}

// import * as ActionTypes from './../constants';
// import { baseUrl } from './../actions';
// import axios from 'axios';
// import AsyncStorage from '@react-native-community/async-storage';
// import { getUserToken } from './getUserToken';
// import RazorpayCheckout from 'react-native-razorpay';

// const dispatchRequestPaymentForCreateTest = () => ({
//     type: ActionTypes.REQUEST_PAYMENT_FOR_CREATE_TEST
// })

// const dispatchSuccessPaymentForCreateTest = res => ({
//     type: ActionTypes.SUCCESS_PAYMENT_FOR_CREATE_TEST,
//     res
// })

// const dispatchErrorFailureForCreateTest = err => ({
//     type: ActionTypes.FAILURE_PAYMENT_FOR_CREATE_TEST,
//     err
// })

// const dispatchClearPaymentForCreateTest = () => ({
//     type: ActionTypes.CLEAR_PAYMENT_FOR_CREATE_TEST
// })

// export const clearAllPaymentForCreateTestData = () => dispatchClearPaymentForCreateTest();





// export const checkoutCreateTest = (testId, bidAmount, testName) => (dispatch, getState) => {
//     AsyncStorage.getItem('authKey', (err, res) => {      

//         dispatch(dispatchRequestPaymentForCreateTest());        
//         if(err) return dispatch(dispatchErrorFailureForCreateTest('something went wrong...', err));
        
//         const {userDetails} = getState().homeData;
//         let username, email, phone;

//         if(userDetails && Object.keys(userDetails)) {
//             username = userDetails.username,
//             email = userDetails.email,
//             phone = userDetails.phone
//         }

//         const description = `Paid by ${username || 'no user'} towards ${testName || testId || 'null'}`

//         var razorPayOptions = {
//             description,
//             image: 'https://image.flaticon.com/icons/svg/321/321828.svg',
//             currency: 'INR',
//             // key: 'rzp_test_1DP5mmOlF5G5ag',
//             key: 'rzp_live_srHGIza8RdhO3Q',
//             amount:  (parseInt(bidAmount, 10) * 100) || '1000',
//             name: '2thepoint',
//             prefill: {
//               email: email || 'srdev3.getinfy@gmail.com',
//               contact: phone || '7204324434',
//               name: username || '2thepointapp'
//             },            
//             theme: {color: '#F37254'}
//           }

//           function sendPaymentStatus(data, status) {
//             const _data = {
//                 testId: testId,
//                 amount: bidAmount,
//                 payment_id: data && data.razorpay_payment_id || null,
//                 test_response: status
//             }

//             const options = {
//                 method: 'post',
//                 url: `${baseUrl}/api/receiveUserPayment`,
//                 data: _data,
//                 headers: {
//                     Authorization: `Bearer ${res}`
//                 }
//             }

//             axios(options).then( ({data}) => {
//                 dispatch(dispatchSuccessPaymentForCreateTest(data))
//             }).catch(e => {
//                 dispatch(dispatchErrorFailureForCreateTest(e));
//             })
//         }
//           RazorpayCheckout.open(razorPayOptions).then((data) => {
//             // handle success
//             // alert(`Success: ${data.razorpay_payment_id}`);
//             // axios({
//             //   url: 'http://toothepoint.appspot.com/paysuccess',
//             //   method: 'post',
//             //   data: {
//             //     payment_id: data.razorpay_payment_id,
//             //     amount: 100
//             //   }
//             // }).then(res => console.log(res))
//             // .catch(e => console.log(e, 'error'));         



//             if(data.razorpay_payment_id) {
//                 sendPaymentStatus(data, 'success');
//             }else{
//                 dispatch(dispatchErrorFailureForCreateTest('something went wrong...', res, 'response error'));
//             }            
//           }).catch((error) => {
//             // handle failure
//             sendPaymentStatus(null, 'failed');
//             dispatch(dispatchErrorFailureForCreateTest('something went wrong...', error.description, 'response error'));
//             // alert(`Error: ${error.code} | ${error.description}`);
//           });
      
//     })

// }